import { render, staticRenderFns } from "./SignupStep2.vue?vue&type=template&id=658d2fcc"
import script from "./SignupStep2.vue?vue&type=script&lang=js"
export * from "./SignupStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports